export default __webpack_public_path__ + "static/media/8.ec3e5e57.jpg";